(function () {
  "use strict";

  // ─── Guard: only initialise once, even if script tag is re-injected ───────────
  if (window.__tstKlaviyoATC) return;
  window.__tstKlaviyoATC = true;

  // ─── Globals ──────────────────────────────────────────────────────────────────
  window._learnq = window._learnq || [];

  const EVENT_NAME = "Added to Cart";
  let lastSentAt     = 0;
  let lastCtx        = null;
  let pageProductCtx = null;

  // ─── Utils ────────────────────────────────────────────────────────────────────
  function whenKlaviyoReady(cb, tries) {
    tries = (tries == null) ? 60 : tries;
    if (window._learnq && typeof window._learnq.push === "function") return cb();
    if (tries <= 0) return console.warn("⚠️ Klaviyo never initialised");
    setTimeout(function () { whenKlaviyoReady(cb, tries - 1); }, 250);
  }
  function dollars(cents) {
    if (cents == null || isNaN(cents)) return 0;
    return Number(cents) / 100;
  }
  function numFromPriceText(str) {
    if (!str) return 0;
    return Number(String(str).replace(/[^0-9.,]/g, "").replace(/,/g, "")) || 0;
  }
  function absUrl(url) {
    if (!url) return window.location.href;
    if (url.startsWith("http")) return url;
    if (url.startsWith("//")) return "https:" + url;
    return window.location.origin + url;
  }
  function relUrl(u) {
    try { return absUrl(u).replace(window.location.origin, ""); } catch (e) { return u || "/"; }
  }
  function getProductHandleFromLocation() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    return m ? m[1] : "";
  }

  // ─── Deduplication ────────────────────────────────────────────────────────────
  function dedupe(ms) {
    var now = Date.now();
    if (now - lastSentAt < (ms || 4000)) {
      console.log("⏭️ Klaviyo ATC dedupe — skipping duplicate within", ms || 4000, "ms");
      return true;
    }
    lastSentAt = now;
    return false;
  }
  function pushEvent(payload) {
    whenKlaviyoReady(function () {
      window._learnq.push(["track", EVENT_NAME, payload]);
      console.log("🟢 Klaviyo 'Added to Cart' pushed", payload);
    });
  }

  // ─── Context builders ─────────────────────────────────────────────────────────
  function buildFromAddResponse(addJson) {
    var item = (addJson && addJson.items && addJson.items[0]) ? addJson.items[0] : addJson;
    if (!item || typeof item !== "object") return {};
    var image = item.image || "";
    if (image && image.startsWith("//")) image = "https:" + image;
    return {
      Name:         item.product_title || item.title || "",
      ProductID:    String(item.product_id != null ? item.product_id : (item.id || "")),
      VariantID:    String(item.variant_id != null ? item.variant_id : ""),
      SKU:          item.sku || "",
      Quantity:     Number(item.quantity != null ? item.quantity : 1),
      PriceDollars: dollars(item.price),
      URL:          absUrl(item.url || window.location.pathname),
      ImageURL:     image,
      Brand:        item.vendor || "",
      Handle:       item.handle || ""
    };
  }

  function scrapeCard(card) {
    if (!card) return {};
    var titleA = card.querySelector(".t4s-product-title a, a.t4s-product-title, a[href*='/products/']");
    var name   = ((titleA && titleA.textContent) || "").trim();
    var url    = titleA ? absUrl(titleA.getAttribute("href") || titleA.href) : window.location.href;
    var handle = "";
    if (titleA) {
      var href = titleA.getAttribute("href") || titleA.href || "";
      var hm   = href.match(/\/products\/([^/?#]+)/i);
      if (hm) handle = hm[1];
    }
    var priceWrap = card.querySelector(".t4s-product-price") || card;
    var saleEl    = priceWrap.querySelector("ins");
    var priceText = ((saleEl ? saleEl.textContent : priceWrap.textContent) || "").trim();
    var priceNum  = numFromPriceText(priceText);
    var vendorA    = card.querySelector(".t4s-product-vendor a");
    var vendorWrap = card.querySelector(".t4s-product-vendor");
    var brand      = ((vendorA ? vendorA.textContent : vendorWrap ? vendorWrap.textContent : "") || "").trim();
    var img   = card.querySelector("img.t4s-product-main-img") || card.querySelector("img");
    var image = "";
    if (img) {
      image = img.currentSrc || img.getAttribute("src") || img.getAttribute("data-src") || "";
      if (!image && img.getAttribute("data-srcset")) image = img.getAttribute("data-srcset").split(" ")[0];
      if (image && image.startsWith("//")) image = "https:" + image;
    }
    var form = card.querySelector("form[action*='/cart/add']");
    var variantId = "", qty = 1;
    if (form) {
      try {
        var fd = new FormData(form);
        variantId = String(fd.get("id") || "");
        qty       = Number(fd.get("quantity") || 1);
      } catch (e) {}
    }
    return { Name: name, URL: url, Handle: handle, PriceDollars: priceNum, Brand: brand, ImageURL: image, VariantID: variantId, Quantity: qty };
  }

  function enrichFromHandle(handle, variantId) {
    if (!handle) return Promise.resolve({});
    return fetch("/products/" + handle + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = variantId
          ? (p.variants || []).find(function (x) { return String(x.id) === String(variantId); })
          : (p.variants || [])[0];
        return {
          ProductID:    String(p.id),
          Name:         p.title,
          Brand:        p.vendor || "",
          URL:          absUrl("/products/" + handle),
          VariantID:    v ? String(v.id) : undefined,
          SKU:          v ? (v.sku || "") : "",
          PriceDollars: v ? dollars(v.price) : undefined,
          ImageURL:     (p.images && p.images[0]) ? absUrl(p.images[0]) : undefined,
          Handle:       handle
        };
      })
      .catch(function () { return {}; });
  }

  function preloadProductPageCtx() {
    var handle = getProductHandleFromLocation();
    if (!handle) return;
    enrichFromHandle(handle, null).then(function (ctx) { pageProductCtx = ctx; });
  }

  function addCartTotals() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return {
          total_price:          dollars(cart.total_price),
          original_total_price: dollars(cart.original_total_price),
          total_discount:       dollars(cart.total_discount)
        };
      })
      .catch(function () { return {}; });
  }

  // ─── Legacy payload builder ───────────────────────────────────────────────────
  function buildLegacyPayload(ctx, totals) {
    var variantId    = ctx.VariantID    || null;
    var productId    = ctx.ProductID    ? Number(ctx.ProductID) : null;
    var quantity     = ctx.Quantity     || 1;
    var priceDollars = ctx.PriceDollars || 0;
    var priceCents   = Math.round(priceDollars * 100);
    var image        = ctx.ImageURL || "";
    if (image && image.startsWith("//")) image = "https:" + image;
    var urlAbs = ctx.URL    || window.location.href;
    var urlRel = relUrl(urlAbs);
    var title  = ctx.Name   || "";
    var vendor = ctx.Brand  || "";
    var handle = ctx.Handle || getProductHandleFromLocation();
    var sku    = ctx.SKU    || "";
    var featuredImage = image
      ? { url: image, alt: title, width: null, height: null, aspect_ratio: null }
      : undefined;
    var items = {
      key:                              variantId ? variantId + ":" + Math.random().toString(16).slice(2) : undefined,
      final_price:                      priceCents,
      gift_card:                        false,
      taxable:                          true,
      original_price:                   priceCents,
      line_price:                       priceCents,
      product_id:                       productId,
      presentment_price:                priceDollars,
      variant_id:                       variantId,
      vendor:                           vendor,
      final_line_price:                 priceCents,
      line_level_total_discount:        0,
      quantity:                         quantity,
      id:                               variantId,
      discounted_price:                 priceCents,
      url:                              urlRel,
      price:                            priceCents,
      discounts:                        [],
      original_line_price:              priceCents,
      line_level_discount_allocations:  [],
      properties:                       ctx.Properties || {},
      product_has_only_default_variant: !Boolean(ctx.VariantID),
      featured_image:                   featuredImage,
      sku:                              sku,
      image:                            image,
      handle:                           handle || "",
      variant_title:                    null,
      product_title:                    title,
      has_components:                   false,
      options_with_values:              [{ value: "Default Title", name: "Title" }],
      title:                            title,
      product_type:                     ctx.ProductType || "",
      variant_options:                  ["Default Title"],
      requires_shipping:                true
    };
    return {
      "Added to Cart Value":  totals && totals.total_price           != null ? totals.total_price           : priceDollars,
      items:                  items,
      total_discount:         totals && totals.total_discount         != null ? totals.total_discount         : 0,
      total_price:            totals && totals.total_price            != null ? totals.total_price            : priceDollars,
      original_total_price:   totals && totals.original_total_price   != null ? totals.original_total_price   : priceDollars
    };
  }

  // ─── Main send functions ──────────────────────────────────────────────────────
  function handleAddResponse(addJson) {
    if (dedupe(4000)) return;
    var ctx    = Object.assign({}, pageProductCtx || {}, lastCtx || {}, buildFromAddResponse(addJson));
    var handle = ctx.Handle || getProductHandleFromLocation();
    var enrich = (!ctx.ProductID || !ctx.ImageURL || ctx.PriceDollars == null) && handle
      ? enrichFromHandle(handle, ctx.VariantID) : Promise.resolve({});
    enrich.then(function (extra) {
      ctx = Object.assign(ctx, extra);
      return addCartTotals();
    }).then(function (totals) {
      pushEvent(buildLegacyPayload(ctx, totals));
    });
  }

  function fallbackFromContextOrPage() {
    if (dedupe(4000)) return;
    var domTitle   = (document.querySelector("h1.product-title, h1") || {}).textContent;
    var domPrice   = document.querySelector(".product-price, .price-item, .t4s-product-price");
    var priceGuess = domPrice ? numFromPriceText(domPrice.textContent) : 0;
    var ctx = Object.assign(
      {
        Name:         (domTitle || "").trim() || (lastCtx && lastCtx.Name) || "",
        URL:          window.location.href,
        PriceDollars: (lastCtx && lastCtx.PriceDollars != null) ? lastCtx.PriceDollars : priceGuess,
        Quantity:     (lastCtx && lastCtx.Quantity)  || 1,
        VariantID:    (lastCtx && lastCtx.VariantID) || undefined,
        ImageURL:     (lastCtx && lastCtx.ImageURL)  || undefined,
        Handle:       (lastCtx && lastCtx.Handle)    || getProductHandleFromLocation()
      },
      pageProductCtx || {}
    );
    var handle = ctx.Handle || getProductHandleFromLocation();
    var enrich = (!ctx.ProductID || !ctx.ImageURL || ctx.PriceDollars == null) && handle
      ? enrichFromHandle(handle, ctx.VariantID) : Promise.resolve({});
    enrich.then(function (extra) {
      ctx = Object.assign(ctx, extra);
      return addCartTotals();
    }).then(function (totals) {
      pushEvent(buildLegacyPayload(ctx, totals));
    });
  }

  // ─── Hook: fetch ─────────────────────────────────────────────────────────────
  // Handles BOTH the shipping suburb patch (previously inline in theme.liquid)
  // AND ATC tracking — single wrapper, no double-wrapping risk.
  (function () {
    var origFetch = window.fetch;
    if (!origFetch) return;

    window.fetch = function () {
      var args = Array.prototype.slice.call(arguments);
      var url  = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";

      // ── Shipping rates suburb patch ──────────────────────────
      if (url.indexOf("/cart/shipping_rates.json") !== -1) {
        try {
          var patchedUrl   = new URL(url, window.location.origin);
          var shippingWrap = document.querySelector("[data-estimate-shipping-wrap]");
          var suburbInput  = shippingWrap && shippingWrap.querySelector("[id^='ShippingSuburb_']");
          if (suburbInput && suburbInput.value) {
            patchedUrl.searchParams.set("shipping_address[city]", suburbInput.value);
            args[0] = patchedUrl.toString();
          }
        } catch (e) {
          console.warn("⚠️ Shipping rates patch error:", e);
        }
      }

      // ── ATC tracking ─────────────────────────────────────────
      var p = origFetch.apply(this, args);

      if (url.indexOf("/cart/add.js") !== -1) {
        p.then(function (res) {
          if (!res || !res.ok) { fallbackFromContextOrPage(); return; }
          res.clone().json()
            .then(handleAddResponse)
            .catch(function () {
              console.warn("⚠️ /cart/add.js not JSON — using fallback");
              fallbackFromContextOrPage();
            });
        }).catch(function () { fallbackFromContextOrPage(); });
      }

      return p;
    };
  })();

  // ─── Hook: XHR ───────────────────────────────────────────────────────────────
  (function () {
    if (!("XMLHttpRequest" in window)) return;
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__isCartAdd = (typeof url === "string" && url.indexOf("/cart/add.js") !== -1);
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__isCartAdd) {
        this.addEventListener("load", function () {
          try {
            if (this.status >= 200 && this.status < 300) {
              handleAddResponse(JSON.parse(this.responseText));
            } else { fallbackFromContextOrPage(); }
          } catch (e) { fallbackFromContextOrPage(); }
        });
      }
      return origSend.apply(this, arguments);
    };
  })();

  // ─── Hook: jQuery.ajax ───────────────────────────────────────────────────────
  (function () {
    if (!window.jQuery || !jQuery.ajax) return;
    var oldAjax = jQuery.ajax;
    jQuery.ajax = function () {
      try {
        var args = arguments[0];
        var url  = (typeof args === "string") ? args : (args && args.url) || "";
        if (url.indexOf("/cart/add.js") !== -1) {
          var origSuccess = args.success;
          args.success = function (data, status, xhr) {
            try { handleAddResponse(data); } catch (e) { fallbackFromContextOrPage(); }
            if (typeof origSuccess === "function") return origSuccess.apply(this, arguments);
          };
        }
      } catch (e) { console.warn("⚠️ jQuery.ajax hook error", e); }
      return oldAjax.apply(this, arguments);
    };
  })();

  // ─── Click listener — context capture ONLY ───────────────────────────────────
  document.addEventListener("click", function (e) {
    var btn = e.target && e.target.closest(
      ".t4s-pr-addtocart, .t4s-pr-item-btn, button[name='add'], [data-add-to-cart], form[action*='/cart/add'] button[type='submit']"
    );
    if (!btn) return;
    var card = btn.closest(".t4s-product-wrapper, .t4s-product, [data-product-id]")
             || document.querySelector(".product") || null;
    var scraped = scrapeCard(card);
    var form = btn.closest("form[action*='/cart/add']")
             || (card && card.querySelector("form[action*='/cart/add']"));
    if (form) {
      try {
        var fd = new FormData(form);
        scraped.VariantID = String(fd.get("id") || scraped.VariantID || "");
        scraped.Quantity  = Number(fd.get("quantity") || scraped.Quantity || 1);
      } catch (e) {}
    }
    lastCtx = Object.assign({}, pageProductCtx || {}, scraped);
  }, true);

  // ─── Form submit — non-AJAX fallback ─────────────────────────────────────────
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.action || form.action.indexOf("/cart/add") === -1) return;
    var card = form.closest(".t4s-product-wrapper, .t4s-product, [data-product-id]")
             || document.querySelector(".product");
    lastCtx = Object.assign({}, pageProductCtx || {}, scrapeCard(card), lastCtx || {});
    try {
      var fd = new FormData(form);
      lastCtx.VariantID = String(fd.get("id") || lastCtx.VariantID || "");
      lastCtx.Quantity  = Number(fd.get("quantity") || lastCtx.Quantity || 1);
    } catch (e) {}
    setTimeout(fallbackFromContextOrPage, 1000);
  }, true);

  // ─── Boot ─────────────────────────────────────────────────────────────────────
  if (getProductHandleFromLocation()) {
    preloadProductPageCtx();
  }

})();
